import { useEffect, useState, type RefObject } from 'react'
import Spinner from '../../Spinner'
import { packetsReplayState } from '../../state/packetsReplayState'
import styles from './ChunksLoadingCard.module.css'

export interface ChunksProgress { loaded: number, total: number }

/** Chunk counters live on nonReactiveState (valtio does not track Set.add), so poll. */
export const useChunksProgress = (): ChunksProgress | null => {
  const [progress, setProgress] = useState<ChunksProgress | null>(null)

  useEffect(() => {
    const read = () => {
      // While seeking the game is hidden and chunks stream in bursts, so both counters
      // jump around; showing that is noise, not progress.
      if (packetsReplayState.isSeeking) {
        setProgress(null)
        return
      }
      const total = appViewer.nonReactiveState.world.chunksTotalNumber
      const loaded = appViewer.nonReactiveState.world.chunksLoaded.size
      const done = appViewer.rendererState.world.allChunksLoaded
      setProgress(!total || done ? null : { loaded: Math.min(loaded, total), total })
    }
    read()
    const interval = setInterval(read, 200)
    return () => clearInterval(interval)
  }, [])

  return progress
}

export default function ChunksLoadingCard ({ progress, cardRef }: { progress: ChunksProgress, cardRef: RefObject<HTMLDivElement> }) {
  const ratio = progress.total > 0 ? Math.min(1, progress.loaded / progress.total) : 0

  return (
    <div ref={cardRef} className={styles.card} data-replay-ui>
      <Spinner size={20} className={styles.spinner} />
      <div className={styles.title}>Загрузка чанков</div>
      <div className={styles.count}>{progress.loaded} / {progress.total}</div>
      <div className={styles.track}>
        <div className={styles.fill} style={{ '--fill': ratio } as React.CSSProperties} />
      </div>
    </div>
  )
}
